import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import withMobileDialog from "@material-ui/core/withMobileDialog";

import { EmptyRecord } from "../../utils/PageUtility";
import RecordPagination from "../../utils/RecordsPagination";
import moment from "moment";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  tableStyle: {
    padding: 0,
  },
    tableHeader: {
        color: "#04137b",
    }
};

const SettingTableStructure = ({
  classes,
  pageIndex,
  pageSize,
  currentPage,
  records,
  filterUsers,
  user,
  handleEdit,
}) => (
  <Table className={classes.table} aria-labelledby="tableTitle">
    <TableHead className={classes.negativeColor} color="primary">
      <TableRow>
        <TableCell className={classes.tableHeader} padding="none">S/N</TableCell>
        <TableCell className={classes.tableHeader} padding="none" component="th">
          Date
        </TableCell>
        <TableCell className={classes.tableHeader} padding="none" component="th">
          Exchange Rate
        </TableCell>
        <TableCell className={classes.tableHeader} padding="none" component="th">
          Created By
        </TableCell>
        <TableCell className={classes.tableHeader} padding="none" component="th">
          Created Date
        </TableCell>
        <TableCell className={classes.tableHeader} padding="none" component="th">
          Approved By
        </TableCell>
        <TableCell className={classes.tableHeader} padding="none" component="th">
          Approved Date
        </TableCell>
        {/* <TableCell padding="none">Status</TableCell> */}
      </TableRow>
    </TableHead>
    <TableBody>
      {records &&
        records.map((item, key) => {
          return (
            <TableRow hover key={key}>
              <TableCell>{pageIndex + key}</TableCell>
              <TableCell padding="none" component="th">
                {moment(item.EffectiveDate).format("YYYY-MM-DD")}
              </TableCell>
              <TableCell padding="none" component="th">
                &#8358; {appHelpers.numberWithCommas(item.Rate)}
              </TableCell>
              <TableCell padding="none" component="th">
                {item.CreatedBy ? filterUsers(item.CreatedBy) : "N/A"}
              </TableCell>
              <TableCell padding="none" component="th">
                {moment(item.CreatedDate).format("YYYY-MM-DD")}
              </TableCell>
              <TableCell padding="none" component="th">
                {filterUsers(item.ApprovedBy)}
              </TableCell>
              <TableCell padding="none" component="th">
                {moment(item.ApprovedDate).format("YYYY-MM-DD")}
              </TableCell>
            </TableRow>
          );
        })}
    </TableBody>
  </Table>
);

class ApprovedTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      flight: false,
    };
  }

  handleClickOpen = (flight) => {
    this.setState({ open: true });
    this.setState({ flight });
    this.props.fetchFlightPassengers(flight.Id);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      classes,
      handleEdit,
      searchError,
      filterUsers,
      user,
      records,
      fetchRecords,
      totalCounts,
      pageSize,
      currentPage,
    } = this.props;
    if (totalCounts === 0)
      return <EmptyRecord message={"No Airline Exchange Rate yet!"} />;
    if (searchError) return <EmptyRecord message={searchError} />;

    const pageIndex = pageSize * (currentPage - 1) + 1;

    return (
      <div>
        {this.props.records && (
          <div
            className={classes.tableResponsive}
            style={{ overflowX: "auto" }}
          >
            <RecordPagination
              fetchMore={fetchRecords}
              totalCount={totalCounts}
              pageSize={pageSize}
              currentPage={currentPage}
              target={
                <SettingTableStructure
                  pageSize={pageSize}
                  currentPage={currentPage}
                  pageIndex={pageIndex}
                  records={records}
                  classes={classes}
                  filterUsers={filterUsers}
                  handleEdit={handleEdit}
                  user={user}
                />
              }
            />
          </div>
        )}
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(ApprovedTable));



// WEBPACK FOOTER //
// ./src/Regional-Views/ExchangeRate/approvedTable.js